import {PolIcon} from "components/PolIcon/policon";
import { useTranslation } from "react-i18next";
import DownloadLink from "v4/components/utils/DownloadLink/DownloadLink";
import React from 'react';

export default function CustomerFileButton({file}) {
    const {t} = useTranslation();
    const {downloadLink = '#', fileLabel, realFileName} = file;

    return (
        <DownloadLink href={downloadLink}
                      fileName={fileLabel}
                      className="customer-file-btn"
                      title={`${t('download')} ${fileLabel}`}
        >
            <PolIcon icon={'download'}/>
            <span>{fileLabel ?? realFileName}</span>
        </DownloadLink>
    )
}
